import ModalCreateAccountReminder from './ModalCreateAccountReminder';

export default ModalCreateAccountReminder;

export { type Props } from './ModalCreateAccountReminder';
